import api from '../utils/api';

export const getAllBudgetYears = () => {
    return api({
        url: '/api/districts/budgetyears/get-all',
        method: 'GET'
    })
}
export const addUpdateBudgetYear = (budgetYear) => {
    return api.post('api/districts/budgetyears/add-update', budgetYear);
}

export const deleteBudgetYear = (budgetYearId) => {
    console.log("delete", budgetYearId);
    return api.delete(`/api/districts/budgetyears/delete/${budgetYearId}`);
}
